import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FortinetMetricsService } from './fortinet-metrics.service';
import { LocationsService } from '../locations/shared/locations.service';


@Component({
    selector: 'app-fortinet-metrics',
    templateUrl: './fortinet-metrics.component.html',
    styleUrls: ['./fortinet-metrics.component.css'],
    standalone: false
})
export class FortinetMetricsComponent implements OnInit {

  isLoading: boolean;
  storeNumber: string = '';
  currentTimeInMilliseconds = Date.now();
  currentDate = new Date(this.currentTimeInMilliseconds).toLocaleDateString("en-US");
  last30DaysTimeInMilliseconds = Date.now() - (30*24*60*60*1000);
  last30DaysDate = new Date(this.last30DaysTimeInMilliseconds).toLocaleDateString("en-US");
  location = [];
  storeIsNotFound: boolean;

  offlineEvents = [];
  totalHoursOffline: number;
  totalHoursOnline: number;
  numOfflineEvents: number;
  avgOfflineDuration: number;
  totalHoursSupposedUptime: number;
  availabilityPercent: number;
  numDevices: number;

  donutChartData = [];
  

  constructor(
    private fortinetMetricsService: FortinetMetricsService,
    private locationsService: LocationsService,
  ) {}

  ngOnInit() { 
    this.isLoading = true;
        Promise.all(
            [
              console.log(this.last30DaysTimeInMilliseconds),
              this.getNumDevices(),
              this.getFortinetData(this.last30DaysTimeInMilliseconds, this.currentTimeInMilliseconds)
            ]
        ).then(() => {
            // this.checkStoreStatus(this.offlineEvents)
            this.getFortinetMetrics(this.offlineEvents, this.last30DaysTimeInMilliseconds, this.currentTimeInMilliseconds)
            this.donutChartData = [{ name: "Available", value: this.totalHoursOnline}, {name: "Unavailable", value: this.totalHoursOffline}]
            this.isLoading = false;
        });
  }

  // ngOnDestroy() { }
 
  getFortinetData(startTime, endTime) {
    const promise = new Promise((resolve) => {
      this.fortinetMetricsService.getOfflineEvents(startTime, endTime).then(response => {
        response.toPromise().then(events_from_response => {
          try {
            this.offlineEvents = events_from_response['message']['ResultSet']['Rows']
            // Removes metadata at index 0 of array
            this.offlineEvents.shift()
          } catch (error) {
            console.log(error.message)
          } finally {
            resolve(true);
          }
        });
      });
    });
    
    return promise;
  }

  getNumDevices() {
    const promise = new Promise((resolve) => {
      this.fortinetMetricsService.getNumDevices().then(response => {
        response.toPromise().then(response => {
          try {
            this.numDevices = response['message']['ResultSet']['Rows'][1]['Data'][0]['VarCharValue']
            this.numDevices = Number(this.numDevices)
          } catch (error) {
            console.log(error.message)
          } finally {
            resolve(true);
          }
        });
      });
    });
  }

  getTotalOfflineTime(eventsArray) {
    this.totalHoursOffline = 0;
    let durationInMinIndex = 5;
    let durationArray = [];
    eventsArray.forEach(event => {
      let durationInHrs = Number(event['Data'][durationInMinIndex]['VarCharValue']) / 60.0;
      durationArray.push(durationInHrs)
      this.totalHoursOffline = this.totalHoursOffline + durationInHrs;
      
    })
    return this.totalHoursOffline
  }
  
  getFortinetMetrics(eventsArray, startTime, endTime) {
    // Total offline time (hrs)
    this.getTotalOfflineTime(eventsArray)

    // Number of offline events
    this.numOfflineEvents = eventsArray.length

    // Average offline duration (hrs)
    this.avgOfflineDuration = this.totalHoursOffline / this.numOfflineEvents
    this.avgOfflineDuration = Math.round((this.avgOfflineDuration + Number.EPSILON) * 100) / 100

    // Availability Percentage
    this.totalHoursSupposedUptime = ((endTime - startTime) / (1000*60*60)) * this.numDevices
    this.totalHoursOnline = this.totalHoursSupposedUptime - this.totalHoursOffline
    this.availabilityPercent = (this.totalHoursOnline / this.totalHoursSupposedUptime) * 100 
    this.availabilityPercent = Math.round((this.availabilityPercent + Number.EPSILON) * 100) / 100
    
  }


  checkStoreStatus(eventsArray) {

    let routerNameIndex = 1;
    let closedLocations = [];
    let openLocations = [];
    this.storeNumber = "00009";

    // eventsArray.forEach(event => {
    //   let routerName = event['Data'][routerNameIndex]['VarCharValue']
    //   let storeNumber = routerName.substring(0,5)
    //   if (!openLocations.includes(storeNumber)) {
    //     this.getLocation(storeNumber)
    //     console.log(location)
    //   }
    // })

    this.getLocation(this.storeNumber);
    console.log(location)


    return;
  }

  getLocation(storeNumber) {
    const promise = new Promise((resolve, reject) => {     
      this.locationsService.getLocationData(storeNumber).then(response => {
        response.toPromise().then(locations_from_response => {
          try {
            locations_from_response["message"]["locationList"].forEach(locations_json => {
              let location = locations_json;
              this.location.push(location);
            });
          } catch (error) {
            console.log("Locations timed out!");
            this.storeIsNotFound = true;
            reject(error);
            return promise;
          } 
          this.storeIsNotFound = false;
          resolve(true);
        });
      });
    });
    return promise;
  }

  dateChanged($event) {
    console.log($event.target.value);
  }


  // resetView() {
  //   this.merakiSwitchStatuses = [];
  //   this.portStatuses = null;
  //   this.fortigate = null;
  //   this.cradlepoints = [];
  //   this.fortigateGlobalStatistics = null;
  //   this.primaryVpnStatus = null;
  //   this.cradlepointLanAvailability = null;
  //   this.interfaceThroughput = null;
  //   this.posServices = [];
    
  // }
}